import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import api from "../../services/api";
import { MdAddAlert } from "react-icons/md";
import { MdNotificationsActive } from "react-icons/md";
import Pagination from "../../components/Pagination";
import editar from "../../assets/editar.png";
import apagar from "../../assets/icons8-apagar-para-sempre-48 (2).png";
import notificacaoHover from "../../assets/icons8-notificação-50.png";
import notificacao from "../../assets/icons8-notificação-50 (1).png";
import pesquisar from "../../assets/pesquisar.png";
import "./styles.scss";
import "react-toastify/dist/ReactToastify.css";
import { isAdmin } from "../../services/auth";
import Swal from "sweetalert2";
import { Tooltip } from "antd";
import { MdDeleteForever } from "react-icons/md";
import "../Notificacao/table.scss";
import { tipoNotificacaoBase } from "../Notificacao/NotificacaoCad";
import { CiEdit } from "react-icons/ci";
import Preloader from "../PreloaderGrids/Preloader";
import logo from "../../assets/logo.png";

function Notificacao() {
  const [marcadores, setMarcadores] = useState([]);
  const [pages, setPages] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const [mediaPage, setMediaPage] = useState(2);
  const [limit, setLimit] = useState(50);
  const tipo = localStorage.getItem("tipo");
  const [isHovered, setIsHovered] = useState(false);
  const colorPagination = "#dee2e6";
  const [totalItems, setTotalItems] = useState(0);
  const [selecionados, setSelecionados] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [valuesStatus, setValuesStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [loadingPage, setLoadingPage] = useState(false);


  const handleSelecionadas = (valor1) => {
    setLimit(valor1);
  };
  const navigate = useNavigate();
  const [isAdminState, setIsAdminState] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const response = await isAdmin();
      if (response.status === "success" && response.isAdmin) {
        setIsAdminState(true);
      } else {
        setIsAdminState(false);
      }
    };

    checkAdmin();
  }, []);

  useEffect(() => {
    fetchDataCache(limit, currentPage);
  }, [currentPage, limit]);





  //=================================
  //TOTAL DE NOTIFICAÇÕES POR PAGINA
  //=================================
  useEffect(() => {
    let mounted = true;

    const MIN_DELAY = 2000; // 2 segundos
    const start = Date.now();

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    async function fetchTotalPages() {
      try {
        if (mounted) setLoadingPage(true);

        const { data } = await api.get("/totalnotificacao", {
          headers: {
            typo: localStorage.getItem("id"),
            inova: localStorage.getItem("inova"),
          },
        });

        if (!mounted) return;

        const total = data.result;
        const totalPages = Math.ceil(total / limit);

        setPages(Array.from({ length: totalPages }, (_, i) => i + 1));
        setTotalItems(total);

      } catch (error) {
        console.error("Erro ao buscar total:", error);
      } finally {
        const elapsed = Date.now() - start;

        if (elapsed < MIN_DELAY) {
          await delay(MIN_DELAY - elapsed);
        }

        if (mounted) {
          setLoadingPage(false);
        }
      }
    }

    fetchTotalPages();

    return () => {
      mounted = false;
    };

  }, [limit, currentPage]);
  //-----------------------------------------------------------------------------------------------

  // DELETAR NOTIFICAÇÃO
  const handleExcluirSelecionados = async () => {


    if (selecionados.length === 0) return;

    /* PEGAR DADOS REAIS DOS ITENS SELECIONADOS */
    const itensSelecionados = marcadores.filter((item) =>
      selecionados.includes(item.id_ocorrencia)
    );

    const selecionadosInfo = itensSelecionados
      .map(
        (n) => `
      <div style="
        border:1px solid rgba(56,189,248,0.20);
        border-radius:12px;
        padding:12px;
        margin-bottom:10px;
        background:rgba(255,255,255,0.03);
        text-align:left;
      ">
        <p style="margin:4px 0;color:#fff">
          <b style="color:#38bdf8">Placa:</b>
          ${n.placa ?? "Sem placa"}
        </p>

        <p style="margin:4px 0;color:#fff">
          <b style="color:#38bdf8">Descrição:</b>
          ${n.mensagem ?? "Sem descrição"}
        </p>

        <p style="margin:4px 0;color:#fff">
          <b style="color:#38bdf8">Tipo:</b>
          ${n.tipo ?? "-"}
        </p>
      </div>
    `
      )
      .join("");

    const result = await Swal.fire({
      width: "500px",
      padding: "0",
      background: "#0f172a",
      color: "#ffffff",

      html: `
    <div class="excluir-notificacao-modal">

      <!-- HEADER -->
      <div class="excluir-notificacao-header">

        <div class="excluir-notificacao-icon">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6l-1 14H6L5 6"></path>
            <path d="M10 11v6"></path>
            <path d="M14 11v6"></path>
            <path d="M9 6V4h6v2"></path>
          </svg>
        </div>

        <div class="excluir-notificacao-header-text">
          <h2>Confirmar exclusão</h2>
          <span>Revise a notificação antes de continuar</span>
        </div>

      </div>


      <!-- CONTEÚDO -->
      <div class="excluir-notificacao-content">

        <div class="excluir-notificacao-description">

          Você está prestes a excluir

          <strong>
            ${selecionados.length}
          </strong>

          ${selecionados.length > 1
          ? "notificações"
          : "notificação"
        }.

        </div>


        <!-- LISTA -->
        ${selecionadosInfo
          ? `
              <div class="excluir-notificacao-box">

                <div class="excluir-notificacao-label">
                  Notificações selecionadas
                </div>

                <div class="excluir-notificacao-lista">
                  ${selecionadosInfo}
                </div>

              </div>
            `
          : ""
        }


        <!-- AVISO -->
        <div class="excluir-notificacao-aviso">

          <svg
            width="17"
            height="17"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="9"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>

          <span>
            Essa ação não poderá ser desfeita.
          </span>

        </div>

      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Excluir",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#dc2626",

      cancelButtonColor: "#1e293b",

      reverseButtons: true,

      customClass: {
        popup: "swal-excluir-notificacao",
        actions: "swal-excluir-notificacao-actions",
        confirmButton: "swal-excluir-notificacao-confirm",
        cancelButton: "swal-excluir-notificacao-cancel"
      }
    });

    if (!result.isConfirmed) return;

    const inicio = Date.now();

    try {
      Swal.fire({
        width: "420px",
        padding: "0",
        background: "#0f172a",
        color: "#ffffff",

        html: `
      <div class="excluindo-notificacoes-modal">

        <div class="excluindo-notificacoes-icon">

          <div class="excluindo-notificacoes-spinner"></div>

        </div>

        <div class="excluindo-notificacoes-content">

          <h2>
            Excluindo notificações...
          </h2>

          <span>
            Aguarde enquanto processamos a exclusão no sistema.
          </span>

        </div>

      </div>
    `,

        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        scrollbarPadding: false,

        customClass: {
          popup: "swal-excluindo-notificacoes"
        },

        didOpen: () => {
          const popup = Swal.getPopup();

          if (popup) {
            popup.style.overflow = "hidden";
            popup.style.padding = "0";
            popup.style.maxHeight = "none";
          }
        }
      })

      await Promise.all(
        selecionados.map((id) =>
          api.put(`/notificacoes/${id}/delete`, {
            apagado_por: localStorage.getItem("clientID"),
          })
        )
      );

      const tempoMinimo = 1800;
      const tempoPassado = Date.now() - inicio;

      if (tempoPassado < tempoMinimo) {
        await new Promise((resolve) =>
          setTimeout(resolve, tempoMinimo - tempoPassado)
        );
      }

      Swal.close();

      await Swal.fire({
        width: "420px",
        padding: "0",
        background: "#0f172a",
        color: "#ffffff",

        html: `
    <div class="exclusao-notificacao-sucesso">

      <div class="exclusao-notificacao-sucesso-icon">

        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>

      </div>

      <div class="exclusao-notificacao-sucesso-content">

        <h2>
          Exclusão concluída
        </h2>

        <span>
          As notificações selecionadas foram excluídas com sucesso.
        </span>

      </div>

    </div>
  `,

        timer: 2200,

        timerProgressBar: true,

        showConfirmButton: false,

        customClass: {
          popup: "swal-exclusao-notificacao-sucesso"
        }
      });

      setSelecionados([]);

      const { data } = await api.get(
        `/totalnotificacao?searchTerm=${searchTerm}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
          },
        }
      );

      const total = data.result;
      setTotalItems(total);

      const totalPages = Math.ceil(total / limit);
      setPages(Array.from({ length: totalPages }, (_, i) => i + 1));

      let newPage =
        currentPage > totalPages ? totalPages : currentPage;

      if (newPage < 1) newPage = 1;

      setCurrentPage(newPage);
      setMediaPage(newPage <= 2 ? 2 : newPage);

      await fetchDataCache(limit, newPage);

    } catch (error) {
      console.error(error);

      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Erro ao excluir",
        text: "Não foi possível excluir as notificações.",
        background: "#0f172a",
        color: "#ffffff",
        confirmButtonColor: "#ef4444",
      });
    }
  };




  const handlePagination = (page) => {
    if (page >= 1 && page <= pages.length) {
      setCurrentPage(page);
      if (page === 1) {
        setMediaPage(2);
      } else if (page === pages.length) {
        setMediaPage(page - 1);
      } else {
        setMediaPage(page);
      }
    }
  };

  // NAVEGAR ENTRE PÁGINAS
  const limits = useCallback((e) => {
    const newLimit = parseInt(e.target.value, 10);

    setLoadingPage(true); //  ativa loading imediatamente
    setLimit(newLimit);
    setCurrentPage(1);
    setMediaPage(2);

  }, []);


  //ATUALIZAÇÃO DE STATUS
  const handleChange = async (id) => {
    const statusAtual = valuesStatus[id];
    const novoStatus = statusAtual === "s" ? "n" : "s";

    // UI otimista
    setValuesStatus(prev => ({
      ...prev,
      [id]: novoStatus,
    }));

    try {
      await api.put(`/notificacaoStatus/${id}`, {
        status: novoStatus,
      });
    } catch (error) {
      // rollback
      setValuesStatus(prev => ({
        ...prev,
        [id]: statusAtual,
      }));
    }
  };






  function getVisiblePages(currentPage, totalPages) {
    const pages = [];

    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, "...", totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, "...", totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }

    return pages;
  }

  // CARREGAMENTO DE DADOS + LOADING (CORRETO)
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  async function fetchDataCache(limit, currentPage) {
    const shouldShowLoader = showLoader;
    const start = Date.now();

    if (shouldShowLoader) {
      setLoading(true); // fade-in
    }

    try {
      const { data } = await api.get(
        `/notificacaopages?limit=${limit}&page=${currentPage}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
            inova: localStorage.getItem("inova"),
          },
        }
      );

      setMarcadores(data.notificacoes || []);


      const statusInicial = {};
      (data.notificacoes || []).forEach((item) => {
        statusInicial[item.notificacao_id] = item.status;
      });

      setValuesStatus(statusInicial);


    } catch (err) {
      console.error(err);
      setMarcadores([]);
    } finally {
      if (shouldShowLoader) {
        const elapsed = Date.now() - start;
        const MIN_DELAY = 5000;

        if (elapsed < MIN_DELAY) {
          await delay(MIN_DELAY - elapsed);
        }

        setLoading(false); //  inicia fade-out

        //  espera o CSS terminar
        await delay(1000);

        setShowLoader(false); //  desmonta suavemente
      }
    }
  }





  //EXIBIÇÃO DE VALORES MAIS LIMPOS
  const getTipoLabel = (tipo) => {
    if (!tipo) return null;

    const tipos = tipo.split("|").map(t => t.trim());

    return (
      <>
        {tipos.map((t, index) => {
          const found = tipoNotificacaoBase.find(item => item.value === t);
          const label = found ? found.label : t;

          return (
            <span key={`${t}-${index}`}>
              {label}
              {index < tipos.length - 1 && <strong style={{ fontSize: "14pt" }}> | </strong>}
            </span>
          );
        })}
      </>
    );
  };


  //EDIÇÃO DE NOTIFICAÇÃO

  const confirmarEdicao = async (id) => {
    const result = await Swal.fire({
      title: "Deseja editar?",
      icon: "question",

      background: "#0f172a",
      color: "#ffffff",

      html: `
      <div style="margin-top:8px">

        <div style="
          color:#cbd5e1;
          font-size:15px;
          line-height:1.6;
          margin-bottom:18px;
          text-align:center;
        ">
          Você será redirecionado para a tela de edição da notificação.
        </div>

        <div style="
          border:1px solid rgba(56,189,248,0.18);
          border-radius:12px;
          padding:14px;
          background:rgba(255,255,255,0.03);
          color:#93c5fd;
          font-size:14px;
          text-align:center;
        ">
          Confirme para continuar.
        </div>

      </div>
    `,

      showCancelButton: true,
      confirmButtonText: "Sim, editar",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#334155",

      reverseButtons: true
    });

    if (result.isConfirmed) {
      navigate(`/maps/editar-notificacao/${id}`);
    }
  };



  //LOADING




return (
  <>
    <ToastContainer />

    <div className="notificacoes-page">
      <div className="notificacoes-ui-panel">

        {/* LOADER */}
        {showLoader && (
          <Preloader
            customClass="notificacoes-ui-preloader"
            show={loading}
            text="Carregando notificações..."
          />
        )}

        {/* CABEÇALHO */}
        <header className="notificacoes-ui-header">
          <div className="notificacoes-ui-heading">
            <div className="notificacoes-ui-heading-icon">
              <MdAddAlert size={23} />
            </div>

            <div className="notificacoes-ui-heading-text">
              <h5 className="notificacoes-ui-title">
                Notificações
              </h5>

              <p className="notificacoes-ui-subtitle">
                Gerencie notificações, alertas e seus status
              </p>
            </div>
          </div>

          <button
            type="button"
            className="notificacoes-ui-close"
            onClick={() => navigate("/maps")}
            aria-label="Fechar notificações"
            title="Fechar"
          >
            ✕
          </button>
        </header>

        {/* BARRA DE AÇÕES */}
        <div className="notificacoes-ui-toolbar">
          <div className="notificacoes-ui-toolbar-description">
            <span className="notificacoes-ui-toolbar-label">
              Gerenciamento
            </span>
            <span className="notificacoes-ui-toolbar-hint">
              Consulte e administre as notificações cadastradas.
            </span>
          </div>

          {isAdminState && (
            <div className="notificacoes-ui-toolbar-actions">
              <Tooltip title="Cadastrar notificação" arrow>
                <Link
                  to="/maps/cadastro-notificacao"
                  className="notificacoes-ui-action notificacoes-ui-action-primary"
                >
                  <MdAddAlert size={18} />
                  <span>Nova notificação</span>
                </Link>
              </Tooltip>

              <Tooltip title="Listar alertas" arrow>
                <Link
                  to="/maps/alertas"
                  className="notificacoes-ui-action notificacoes-ui-action-secondary"
                >
                  <MdNotificationsActive size={18} />
                  <span>Ver alertas</span>
                </Link>
              </Tooltip>
            </div>
          )}
        </div>

        {/* ÁREA DA TABELA */}
        <main className="notificacoes-ui-table-container">
          <img src={logo} className="logo"></img>



          {!loading && marcadores.length === 0 && (
            <div className="notificacoes-ui-empty">
              <MdNotificationsActive size={34} />

              <strong>Nenhuma notificação encontrada</strong>

              <span>
                Não existem notificações para exibir no momento.
              </span>
            </div>
          )}

          {!loading && marcadores.length > 0 && (
            <div className="notificacoes-ui-table-scroll">
              <table className="notificacoes-ui-table">
                <thead>
                  <tr>
                    <th scope="col">Placa</th>
                    <th scope="col">Grupo</th>
                    <th scope="col">Tipo</th>

                    {isAdminState && (
                      <th scope="col" className="notificacoes-ui-status-heading">
                        Status
                      </th>
                    )}

                    {isAdminState && (
                      <th
                        scope="col"
                        className="notificacoes-ui-selection-heading"
                      >
                        <label
                          className="notificacoes-ui-checkbox"
                          title="Selecionar todas as notificações"
                        >
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelecionados(
                                  marcadores.map((m) => m.notificacao_id)
                                );
                              } else {
                                setSelecionados([]);
                              }
                            }}
                            checked={
                              marcadores.length > 0 &&
                              selecionados.length === marcadores.length
                            }
                          />
                          <span className="notificacoes-ui-checkmark" />
                        </label>
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {marcadores.map((marcador) => (
                    <tr key={marcador.notificacao_id}>
                      {/* PLACA */}
                      <td className="notificacoes-ui-placa-cell">
                        {marcador.placa ? (
                          (() => {
                            const placaFormatada = marcador.placa
                              .replace(/'/g, "")
                              .replace(/,/g, " | ");

                            return (
                              <div className="notificacoes-ui-placa-content">
                                <span className="notificacoes-ui-placa-text">
                                  {placaFormatada.length > 50
                                    ? placaFormatada.substring(0, 50) + "..."
                                    : placaFormatada}
                                </span>

                                {placaFormatada.length > 50 && (
                                  <button
                                    type="button"
                                    className="notificacoes-ui-read-more"
                                    onClick={() =>
                                      Swal.fire({
                                        title: "Placas cadastradas",
                                        background: "#f4f8fb",
                                        color: "#304858",
                                        html: `
                                          <div style="
                                            margin-top: 8px;
                                            max-height: 320px;
                                            overflow: auto;
                                            text-align: left;
                                            padding: 6px;
                                          ">
                                            <div style="
                                              border: 1px solid #d4e0e9;
                                              border-radius: 8px;
                                              padding: 14px;
                                              background: #ffffff;
                                              color: #405768;
                                              font-size: 14px;
                                              line-height: 1.8;
                                              word-break: break-word;
                                            ">
                                              ${placaFormatada}
                                            </div>
                                          </div>
                                        `,
                                        confirmButtonText: "Fechar",
                                        confirmButtonColor: "#287db5",
                                        customClass: {
                                          popup: "notificacoes-ui-swal-placas",
                                        },
                                      })
                                    }
                                  >
                                    Ler mais
                                  </button>
                                )}
                              </div>
                            );
                          })()
                        ) : (
                          <span className="notificacoes-ui-empty-value">
                            Não possui placa cadastrada
                          </span>
                        )}
                      </td>

                      {/* GRUPO */}
                      <td>
                        {marcador.grupo ? (
                          <span className="notificacoes-ui-group">
                            {marcador.grupo}
                          </span>
                        ) : (
                          <span className="notificacoes-ui-empty-value">
                            Não possui grupo cadastrado
                          </span>
                        )}
                      </td>

                      {/* TIPO */}
                      <td>
                        <span className="notificacoes-ui-type">
                          {getTipoLabel(marcador.tipo)}
                        </span>
                      </td>

                      {/* STATUS */}
                      {isAdminState && (
                        <td className="notificacoes-ui-status-cell">
                          <label className="notificacoes-ui-switch">
                            <input
                              type="checkbox"
                              checked={
                                valuesStatus[marcador.notificacao_id] === "s"
                              }
                              onChange={() =>
                                handleChange(marcador.notificacao_id)
                              }
                              aria-label={`Alterar status da notificação ${marcador.notificacao_id}`}
                            />
                            <span className="notificacoes-ui-switch-slider" />
                          </label>
                        </td>
                      )}

                      {/* AÇÕES */}
                      {isAdminState && (
                        <td className="notificacoes-ui-row-actions-cell">
                          <div className="notificacoes-ui-row-actions">
                            <Tooltip
                              title="Editar notificação"
                              arrow
                              placement="bottom"
                            >
                              <button
                                type="button"
                                className="notificacoes-ui-edit"
                                onClick={() =>
                                  confirmarEdicao(marcador.notificacao_id)
                                }
                                aria-label="Editar notificação"
                              >
                                <CiEdit size={22} />
                              </button>
                            </Tooltip>

                            <label
                              className="notificacoes-ui-checkbox"
                              title="Selecionar notificação"
                            >
                              <input
                                type="checkbox"
                                checked={selecionados.includes(
                                  marcador.notificacao_id
                                )}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelecionados([
                                      ...selecionados,
                                      marcador.notificacao_id,
                                    ]);
                                  } else {
                                    setSelecionados(
                                      selecionados.filter(
                                        (id) =>
                                          id !== marcador.notificacao_id
                                      )
                                    );
                                  }
                                }}
                              />
                              <span className="notificacoes-ui-checkmark" />
                            </label>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </main>

        {/* EXCLUSÃO EM LOTE */}
        {isAdminState && selecionados.length > 0 && (
          <div className="notificacoes-ui-selected">
            <span>
              <strong>{selecionados.length}</strong>{" "}
              {selecionados.length === 1
                ? "notificação selecionada"
                : "notificações selecionadas"}
            </span>

            <button
              type="button"
              className="notificacoes-ui-delete-selected"
              onClick={handleExcluirSelecionados}
              title="Excluir notificações selecionadas"
            >
              <MdDeleteForever size={18} />
              <span>Excluir selecionadas</span>
            </button>
          </div>
        )}

        {/* RODAPÉ E PAGINAÇÃO */}
        <footer className="notificacoes-ui-footer">
          <div className="notificacoes-ui-summary">
            <span>
              Total de{" "}
              <strong>
                {totalItems}{" "}
                {totalItems === 1 ? "notificação" : "notificações"}
              </strong>
            </span>

            <span className="notificacoes-ui-divider" />

            <span>
              Página <strong>{currentPage}</strong> de{" "}
              <strong>{pages.length}</strong>
            </span>
          </div>

          <nav
            className="notificacoes-ui-pagination"
            aria-label="Paginação de notificações"
          >
            <button
              type="button"
              className="notificacoes-ui-page-button"
              onClick={() => handlePagination(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Página anterior"
            >
              ‹
            </button>

            {getVisiblePages(currentPage, pages.length).map(
              (page, index) => (
                <span
                  className="notificacoes-ui-page-item"
                  key={`${page}-${index}`}
                >
                  {page === "..." ? (
                    <span className="notificacoes-ui-page-dots">…</span>
                  ) : (
                    <button
                      type="button"
                      className={`notificacoes-ui-page-button ${
                        page === currentPage ? "active" : ""
                      }`}
                      onClick={() =>
                        page !== currentPage && handlePagination(page)
                      }
                      aria-current={
                        page === currentPage ? "page" : undefined
                      }
                    >
                      {page}
                    </button>
                  )}
                </span>
              )
            )}

            <button
              type="button"
              className="notificacoes-ui-page-button"
              onClick={() => handlePagination(currentPage + 1)}
              disabled={currentPage === pages.length || pages.length === 0}
              aria-label="Próxima página"
            >
              ›
            </button>
          </nav>

          <div className="notificacoes-ui-page-size">
            <label htmlFor="notificacoes-ui-limit">Exibir</label>

            <select
              id="notificacoes-ui-limit"
              onChange={limits}
              value={limit}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value={totalItems}>Todas</option>
            </select>

            <span>por página</span>
          </div>
        </footer>

      </div>
    </div>
  </>
);

}
export default Notificacao;
